<template>
  <div id="orderlist" style="width: 100%;height: 100%">
    <el-row>
      <el-col>
        <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
          style="padding-top:0;margin-top:0">
          <el-form-item label="客户：">
            <el-select size="medium" v-model="searchForm.TC_ID" filterable placeholder="请选择" clearable
              @clear="clearEvent()" @change="onTCChange">
              <el-option v-for="item in companys" :key="item.value" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点：">
            <el-select size="medium" v-model="searchForm.PROJECT_ID" filterable multiple placeholder="请选择" clearable
              @change="queryDkList">
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME"
                :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口：">
            <el-select size="medium" v-model="searchForm.DK_ID" filterable multiple placeholder="请选择" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" v-model="searchForm.SUPPLIER_ID" filterable placeholder="请选择" clearable>
              <el-option v-for="item in supplierList" :key="item.value" :label="item.SUPPLIER_NAME"
                :value="item.SUPPLIER_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input size="medium" v-model="searchForm.orderCode" style="width: 180px;" clearable></el-input>
          </el-form-item>
          <el-form-item label="订单类型：">
            <el-select filterable v-model="searchForm.ADDED_ORDER" placeholder="请选择" clearable>
              <el-option v-for="item in addedOrderTypeList" :key="item.value" :label="item.NAME" :value="item.ID" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" id="search" @click="handleSearch()">筛选</el-button>
            <el-button size="medium" type="primary" plain @click="batchExport()">批量导出</el-button>
            <el-button size="medium" type="primary" plain @click="purchaseOrderExport()">采购订单导出</el-button>
            <el-button size="medium" type="primary" plain @click="采购销售信息合并导出()">采购销售信息合并导出</el-button>
            <el-button size="medium" type="primary" plain @click="PDF导出(1)">销售单PDF导出</el-button>
            <el-button size="medium" type="primary" plain @click="PDF导出(2)">采购单PDF导出</el-button>

            <el-button v-show="fun_dic[1110203]" type="primary" plain @click="导出合并PDF(2)">导出合并PDF</el-button>


          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="margin-top: 10px;">
      <el-col :span="24">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border stripe show-summary
          :summary-method="getSummaries" style="width: 100%">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="ID" label="订单ID" width="100"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="VENDOR_NAME" label="供货商"></el-table-column>
          <el-table-column prop="TC_NAME" label="客户"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="门店"></el-table-column>
          <el-table-column prop="DK_NAME" label="档口"></el-table-column>
          <el-table-column prop="TOTAL_GYS_FEE" label="采购验收总金额"></el-table-column>
          <el-table-column prop="REAL_SALE_FEE" label="销售验收总金额">
            <template slot-scope="scope">
              <span>{{ Number(scope.row.REAL_SALE_FEE) ? scope.row.REAL_SALE_FEE : scope.row.SALE_FEE }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ADDED_ORDER" label="订单类型">
            <template slot-scope="scope">
              {{ getAddedOrderTypeLabel(scope.row.ADDED_ORDER) }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" width="190px;" label="操作" min-width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" @click="oneButtonAccept(scope.row)">按订购数量一键验收</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 导出合并PDF订单 -->
    <el-dialog title="批量导出" center :visible.sync="exportOrderFormDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="exportMergeForm" ref="exportMergeForm" :inline="true" :rules="rules">
        <el-form-item label="客户：" prop="COMPANY" label-width='150px'>
          <label slot="label">客&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;户：</label>
          <el-select style="width:300px" v-model="exportMergeForm.COMPANY" filterable placeholder="请选择" clearable
            @change="queryProjectList()">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店：" prop="PROJECT" label-width='150px'>
          <label slot="label">门&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;店：</label>
          <el-select style="width:300px" v-model="exportMergeForm.PROJECT" filterable placeholder="请选择" clearable>
            <el-option v-for="item in projects" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：" prop="SEND_DAY" label-width='150px'>
          <el-date-picker style="width:300px" :picker-options="pickerOptions" v-model="exportMergeForm.SEND_DAY"
            type="date" placeholder="选择日期" :clearable="false"></el-date-picker>
        </el-form-item>
        <el-form-item label="是否打印价格：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportMergeForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否打印送货数量：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="exportMergeForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量：" label-width='150px'>
          <el-radio v-model="exportMergeForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="exportMergeForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportClose">取 消</el-button>
        <el-button size="small" :loading="loading1" @click="submitExportAdd('exportMergeForm')">确 定</el-button>
      </div>
    </el-dialog>
    <DSOrderExportPDFForm v-if="销售价采购价PDF模态框" :prop-visible="销售价采购价PDF模态框" :price-type="销售价采购价PDF表单.价格类型"
      :order-status="2" :is-yfd="isYFD" :order-id-list="checkedArray.map(({ ORDER_ID }) => ORDER_ID)"
      :prop-customer-list="companys" @close="销售价采购价PDF模态框 = false">
    </DSOrderExportPDFForm>
  </div>
</template>
<script>
import {
  DSOrderFun, queryCustomerFun, haveSupplierFun, checkOrder,
} from '@/assets/api/DSOrder';
import { historyOrderDetailFun } from '@/assets/api/shopOrderManage';
import {
  selectProjectFun, batchExportFun, getHaveSupplyRelationshipProjectList,
} from '@/assets/api/sellOrder';
import date from '@/assets/common/date';
import { frontEndFun } from '@/assets/api/frontFun';
import http from '@/assets/common/http';
import util from '@/assets/common/util';
import DSOrderExportPDFForm from './DSOrderExportPDFForm.vue';
import validation from '@/assets/common/validation';
import orderMixin from '@/assets/common/mixins/orderMixin.js';

export default {
  components: {
    DSOrderExportPDFForm,
  },
  mixins: [orderMixin],
  data () {
    return {
      isYFD: 0,
      PAGE_ID: '11102', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1110201: 0, 1110202: 0, 1110203: 0 }, // 功能ID 一旦规定不要轻易改动
      rules: {
        COMPANY: [
          { required: true, message: '请选择客户', trigger: 'blur' },
        ],
      },
      loading1: false,
      points: [],
      dkList: [],
      companys: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 15,
      searchForm: {
        TC_ID: '',
        DAY_INTERVAL: [],
        PROJECT_ID: [],
        SEND_DAY: '',
        DK_ID: [],
      },
      tableData: [],
      checkedArray: [],
      supplierList: [],
      exportOrderFormDialog: false,
      exportMergeForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
      },
      projects: [],
      销售价采购价PDF模态框: false,
      销售价采购价PDF表单: {
        价格类型: 1,
      },
    };
  },
  computed: {
    // 上一次的搜索结果和条件
    DS_ORDER_CONFIRM_LIST_CONDITION () {
      return this.$store.state.DS_ORDER_CONFIRM_LIST_CONDITION;
    },
  },
  created () {
    if (this.DS_ORDER_CONFIRM_LIST_CONDITION.CONDITION) {
      this.searchForm = this.DS_ORDER_CONFIRM_LIST_CONDITION.CONDITION;
      this.currentPage = this.DS_ORDER_CONFIRM_LIST_CONDITION.CURRENT_PAGE;
    }
    this.queryProject();
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 15;
    this.queryBeforeFun();
    this.queryCustomer();
    this.querySupplier();
    if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
      this.queryDkList();
    }
    this.queryData();
  },
  methods: {

    // 采购订单导出
    purchaseOrderExport () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 15,
        STATUS: 2,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 必传GYS_ID(供应链ID),STATUS(状态)(1:待送,2待确认,3历史),START_DAY(开始日期),END_DAY(结束日期)
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择开始日期和结束日期', type: 'warning' });
        return;
      }
      // 选传TC_ID(客户ID),SUPPLIER_ID(供应商ID)
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      http.post(params).then((result) => {
        if (result[0].FILE_PATH !== '') {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取项目点
    queryProject () {
      const params = {};
      if (this.searchForm.TC_ID) params.TC_ID = this.searchForm.TC_ID;
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变项目点 拉取档口
    queryDkList () {
      if (this.searchForm.PROJECT_ID.length === 0) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECTS_ID = this.searchForm.PROJECT_ID;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = util.listRemoveDuplicates(result);
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 批量导出
    batchExport () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 13,
        STATUS: 2,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 必传GYS_ID(供应链ID),STATUS(状态)(1:待送,2待确认,3历史),START_DAY(开始日期),END_DAY(结束日期)
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择开始日期和结束日期', type: 'warning' });
        return;
      }
      // 选传TC_ID(客户ID),SUPPLIER_ID(供应商ID)
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      http.post(params).then((result) => {
        if (result[0].FILE_PATH !== '') {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCustomer () {
      const params = {};
      queryCustomerFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.companys = result[0].company;
          } else {
            this.companys = [];
          }
        }).catch((error) => {
        });
    },
    querySupplier () {
      const params = {};
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER_ID;
      }
      haveSupplierFun()
        .then((result) => {
          this.supplierList = result.length > 0 ? result : [];
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    clearEvent () {
      this.queryData();
    },
    // 多选框
    handleSelectionChange (val) {
      this.checkedArray = val.map((item) => ({ ORDER_ID: item.ID }));
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    detail (row) {
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('tcName', row.TC_NAME);
      sessionStorage.setItem('DSOrderDetailTitle', JSON.stringify({
        ORDER_ID: row.ID,
        SEND_DATE: row.SEND_DAY,
        CUSTOMER_NAME: row.TC_NAME,
        PROJECT_NAME: row.PROJECT_NAME,
        DK_NAME: row.DK_NAME,
      }));
      this.$router.push({ path: '/DSConfirmDetail/detail' });
    },
    // -----------------------获取新订单列表
    queryData () {
      if (this.searchForm.orderCode && !validation.订单ID验证(this.searchForm.orderCode)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        PAGESIZE: Number(this.pageSize) ? Number(this.pageSize) : 20,
        PAGEINDEX: this.currentPage - 1,
        STATUS: 2,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.orderCode) {
        params.ORDER_ID = this.searchForm.orderCode;
      }
      if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID && this.searchForm.DK_ID.length !== 0) {
        params.DK_IDS = this.searchForm.DK_ID;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      DSOrderFun(params).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
          this.$store.dispatch('SET_DS_ORDER_CONFIRM_LIST_CONDITION', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    print (row) {
      this.$router.push({ name: 'printPreview' });
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('pricePrint', 0);
    },
    pricePrint (row) {
      this.$router.push({ name: 'printPreview' });
      sessionStorage.setItem('orderId', row.ID);
      sessionStorage.setItem('pricePrint', 1);
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'TOTAL_GYS_FEE') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        }
      });
      this.sums = sums;
      return sums;
    },
    handleSearch () {
      this.currentPage = 1;
      this.queryData();
    },
    exportAddPdf () {
      this.exportOrderFormDialog = true;
    },
    submitExportAdd () {
      if (this.exportMergeForm.SEND_DAY) {
        this.$refs.exportMergeForm.validate((valid) => {
          if (valid) {
            const params = {
              SEND_DAY: date(this.exportMergeForm.SEND_DAY, '%F'),
              TC_ID: this.exportMergeForm.COMPANY,
              PRICE_FLAG: Number(this.exportMergeForm.printPrice),
              ORDER_FLAG: 1,
              SEND_COUNT_FLAG: Number(this.exportMergeForm.printCount),
              DS_FLAG: 1,
              iRCONTFlag: Number(this.exportMergeForm.printReal),
            };
            if (this.exportMergeForm.PROJECT !== '') {
              params.PROJECT_ID = this.exportMergeForm.PROJECT;
            }
            this.loading1 = true;
            batchExportFun(params).then((result) => {
              window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
              this.exportMergeFormDialog = false;
              this.$nextTick(() => {
                this.$refs.exportMergeForm.resetFields();
              });
              this.loading1 = false;
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              this.loading1 = false;
            });
          } else {
            return false;
          }
        });
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
    },
    exportClose () {
      this.exportOrderFormDialog = false;
    },
    queryProjectList () {
      const paramsProject = {
        TC_ID: this.exportMergeForm.COMPANY,
      };
      selectProjectFun(paramsProject).then((result) => {
        this.projects = result[0].list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    async oneButtonAccept (row) {
      let detail;
      const params1 = {
        ID: Number(row.ID),
        INCLUDE_THIRD_PARTY: 1,
      };
      await historyOrderDetailFun(params1).then((result) => {
        detail = result[0].list;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      if (!detail.length) {
        this.$message.show({ text: '该订单为空，无法按订购数量验收', type: 'warning' });
        return;
      }
      const submitArr = detail.map((item) => ({
        ORDER_DETAIL_ID: Number(item.ID),
        PRODUCT_CODE: item.PRODUCT_CODE,
        NEW_COUNT: Number(item.PRODUCT_COUNT),
        PRODUCT_FEE: Number(item.TOTAL_FEE),
      }));
      const params2 = {
        ORDER_ID: Number(row.ID),
        PRODUCT_ARRAY: submitArr,
      };
      await checkOrder(params2).then((result) => {
        if (result) {
          this.$message.show({ text: '按订购数量验收成功', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.queryData();
    },
    采购销售信息合并导出 () {
      const params = {
        SERVICE_ID: '10179',
        OTYPE: 66,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        STATUS: 2,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DAY_INTERVAL != null && this.searchForm.DAY_INTERVAL.length == 2) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.orderCode) {
        params.ORDER_ID = this.searchForm.orderCode;
      }
      if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length !== 0) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.DK_ID && this.searchForm.DK_ID.length !== 0) {
        params.DK_IDS = this.searchForm.DK_ID;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        params.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      http.post(params).then((result) => {
        if (result[0] && result[0].FILE_PATH) {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    导出合并PDF (价格类型) {
      this.isYFD = 1;
      this.销售价采购价PDF表单.价格类型 = 价格类型;
      this.销售价采购价PDF模态框 = true;
    },
    PDF导出 (价格类型) {
      this.销售价采购价PDF表单.价格类型 = 价格类型;
      this.销售价采购价PDF模态框 = true;
    },
    onTCChange () {
      this.searchForm.PROJECT_ID = [];
      this.queryProject();
    },
  },
};
</script>
<style scoped>
.el-button--text {
  margin: 0 0 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DSOrder/DSOrderConfirmList.vue